<div
  rtScrollable
  class="sidebar"
  [class.has-expander]="hasExpander"
  [class.large]="size === 'large'"
  [class.collapsed]="collapseState === 'collapsed'"
  [@collapseHorizontal]="collapseState"
  (@collapseHorizontal.start)="animationEvent.emit($event)"
  (@collapseHorizontal.done)="animationEvent.emit($event)"
>
  <ng-content></ng-content>
</div>

<div *ngIf="hasExpander" class="expander-wrap">
  <div class="expander">
    <div
      class="controls-container"
      [class.collapsed]="isMinimized"
      [class.shortcuts-disabled]="!isMinimized && !enableExpanderShortcuts"
    >
      <div *ngIf="!isMinimized && enableExpanderShortcuts" class="hotkey-controls-group">
        <div class="symbol-wrapper" margin-right-small-xx>
          <span margin-lr-small-xxx>[</span>
        </div>
        <div class="symbol-wrapper">
          <span margin-lr-small-xxx>]</span>
        </div>
        <div class="label">{{ 'app.sidebar.show_hide' | translate }}</div>
      </div>
      <rt-icon-button
        shape="square"
        [iconName]="isMinimized ? 'chevron-right' : 'chevron-left'"
        variant="transparent-dark"
        (click)="toggleSidebar(!isMinimized)"
      >
      </rt-icon-button>
    </div>
  </div>
</div>
